import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Special from "@/pages/special/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "special/:id", element: <Special /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;